export const UPDATE_PIN_START = 'UPDATE_PIN_START';
export const UPDATE_PIN_SUCCESS = 'UPDATE_PIN_SUCCESS';
export const UPDATE_PIN_FAILURE = 'UPDATE_PIN_FAILURE';
export const UPDATE_PIN_END = 'UPDATE_PIN_END';
export const CLEAR_UPDATE_PIN = 'CLEAR_UPDATE_PIN';
